import { ActionContext, ILogAttributes, TLogContent } from './types';

export const convertActionContextToReportData = (actionCtx: ActionContext): [TLogContent, ILogAttributes] => {
  const { attributes, content } = actionCtx;
  return [
    content || '',
    {
      trigger: attributes?.trigger,
      trigger_id: attributes?.triggerID,
      trigger_type: attributes?.triggerType,
      instance_id: attributes?.instanceID,
      status: attributes?.status,
      phase: attributes?.phase,
      start_at: attributes?.startAt,
      end_at: attributes?.endAt,
      duration_ms: attributes?.duration_ms,
    },
  ];
};